<template>
  <div
    :class="appCssClass"
    class="mlui-servererror tw-flex tw-flex-col align-items-center justify-content-center tw-h-full w-auto">
    <img
      :src="logoSource"
      alt="logo"
      class="logo">
    <FontIcon 
      :iconClass="appIconClass" 
      class="mlean-display-3" />
    <div
      class="font-weight-bold mlean-display-3 text-center mb-2"
      v-html="errorTitle || defaultErrorTitle" />
    <div class="mlean-display-4 text-center">
      <span v-html="errorMsg || defaultErrorMsg" />
      <div
        v-if="errorMsg!=''"
        class="mt-5 text-center">
        {{ $t('common.messages.alternative_way_to_contact' ) }}
        <a
          :href="mailToSupport"
          target="_top"><u>{{ $t('common.messages.support') }}</u></a>
      </div>
    </div>
  </div>
</template>

<script>
import FontIcon from "./FontIcon"
import { M_LEAN_EMAIL_SUPPORT } from 'frontcore/constants/constants'

export default {
  components: {
    FontIcon,
  },
  props: {
    appCssClass: {
      type: String,
      default: "main",
    },
    appIconClass: {
      type: String,
      default: '',
    },
    errorMsg: {
      type: String,
      default: '',
    },
    errorTitle: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      logoSource: `${API_URL}/media/files/branding/logo-login.png`,
      mailToSupport: `mailto: ${M_LEAN_EMAIL_SUPPORT}?Subject=MPS%20Update%20Error`,
      defaultErrorTitle: 'Oops, server connection error',
      defaultErrorMsg: `Imposible to connect with <span class="font-italic">${API_URL}</span>`,
    }
  },
}
</script>

<style lang="scss" scoped>
.mlui-servererror {
  background-color: $blue-light;
}
.logo {
  width: 10rem;
  position: absolute;
  left: 4rem;
  top: 4rem;
  @include is-phone {
    width: 8rem;
  }
}
.mlean-display-3 {
    font-size: 4.5rem;
    font-weight: 300;
    line-height: 1.2;
    @include is-phone {
      font-size: 2.25rem;
      line-height: 1.0;
    }
  }
  .mlean-display-4 {
    font-size: 3.5rem;
    font-weight: 300;
    line-height: 1.2;
    @include is-phone {
      font-size: 1.75rem;
      line-height: 1.0;
    }
  }
</style>
